// import SnakeCaseKeys from "snakecase-keys";
import CamelcaseKeys from "camelcase-keys";
import snakecaseKeys from "snakecase-keys";
import { DvAxiosRequest } from '../../components/utility/dvGeneralUtilities';

const getGeneralInfosService = () => {
  const requestOptions = {
    url: 'ehrAdmin/generalInfos',
    method: 'get',
  };

  return DvAxiosRequest(requestOptions, function (response) {
    return {
      status: 1,
      results: CamelcaseKeys(response.data, {"deep": true})
    };
  });
};

const getClinicsWithMostPatientsService = () => {
  const requestOptions = {
    url: 'ehrAdmin/generalInfos/clinicsWithMostPatients',
    method: 'get',
  };

  return DvAxiosRequest(requestOptions, function (response) {
    return {
      status: 1,
      results: CamelcaseKeys(response.data, {"deep": true})
    };
  });
};

const getUsersWithMostPatientsService = () => {
  const requestOptions = {
    url: 'ehrAdmin/generalInfos/usersWithMostPatients',
    method: 'get',
  };

  return DvAxiosRequest(requestOptions, function (response) {
    return {
      status: 1,
      results: CamelcaseKeys(response.data, {"deep": true})
    };
  });
};

const getBackgroundLogsService = () => {
  const requestOptions = {
    url: 'ehrAdmin/generalInfos/backgroundJobLogs',
    method: 'get',
  };

  return DvAxiosRequest(requestOptions, function (response) {
    return {
      status: 1,
      results: CamelcaseKeys(response.data, { "deep": true })
    };
  });
}

const getGeneralErrorLogsService = () => {
  const requestOptions = {
    url: 'ehrAdmin/generalInfos/logs',
    method: 'get',
  };

  return DvAxiosRequest(requestOptions, function (response) {
    return {
      status: 1,
      results: CamelcaseKeys(response.data, { "deep": true })
    };
  });
}

const getClinicsService = () => {
  const requestOptions = {
    url: 'ehrAdmin/clinics',
    method: 'get',
  };

  return DvAxiosRequest(requestOptions, function (response) {
    return {
      status: 1,
      results: CamelcaseKeys(response.data, { "deep": true })
    };
  });
};

const getDatabasesService = () => {
  const requestOptions = {
    url: 'ehrAdmin/databaseInfos',
    method: 'get',
  };

  return DvAxiosRequest(requestOptions, function (response) {
    return {
      status: 1,
      results: CamelcaseKeys(response.data, {"deep": true})
    };
  });
};

const getBackupsService = () => {
  const requestOptions = {
    url: 'ehrAdmin/databaseInfos/backups',
    method: 'get',
  };

  return DvAxiosRequest(requestOptions, function (response) {
    return {
      status: 1,
      results: CamelcaseKeys(response.data, {"deep": true})
    };
  });
}

const getLogsDataService = (filters) => {
  const params = new URLSearchParams(snakecaseKeys(filters));
  const requestOptions = {
    url: 'ehrAdmin/generalInfos/logs?' + params.toString(),
    method: 'get',
  };

  return DvAxiosRequest(requestOptions, function (response) {
    return {
      status: 1,
      results: CamelcaseKeys(response.data, { "deep": true })
    };
  });
}

const createNewClinicService = (values) => {
  const requestOptions = {
    url: 'ehrAdmin/clinics',
    method: 'post',
    data: snakecaseKeys(values, { deep: true })
  };

  return DvAxiosRequest(requestOptions, function (response) {
    return {
      status: 1,
      results: CamelcaseKeys(response.data, { "deep": true })
    };
  });
}

const updateClinicService = (clinicId, values) => {
  const requestOptions = {
    url: `ehrAdmin/clinics/${clinicId}`,
    method: 'put',
    data: snakecaseKeys(values, { deep: true })
  };

  return DvAxiosRequest(requestOptions, function (response) {
    return {
      status: 1,
      results: CamelcaseKeys(response.data, { 'deep': true })
    };
  });
}

const getSingleClinicDetailsService = (clinicId) => {
  const requestOptions = {
    url: `ehrAdmin/clinics/${clinicId}`,
    method: 'get',
  };

  return DvAxiosRequest(requestOptions, function (response) {
    return {
      status: 1,
      results: CamelcaseKeys(response.data, { "deep": true })
    };
  });
}

const createNewUserService = (values) => {
  const requestOptions = {
    url: 'ehrAdmin/users',
    method: 'post',
    data: snakecaseKeys(values, { deep: true })
  };

  return DvAxiosRequest(requestOptions, function (response) {
    return {
      status: 1,
      results: CamelcaseKeys(response.data, { "deep": true })
    };
  });
}

const updateUserService = (userId, values) => {
  const requestOptions = {
    url: `ehrAdmin/users/${userId}`,
    method: 'put',
    data: snakecaseKeys(values, { deep: true })
  };

  return DvAxiosRequest(requestOptions, function (response) {
    return {
      status: 1,
      results: CamelcaseKeys(response.data, { "deep": true })
    };
  });
}

const getUserDetailsService = (userId) => {
  const requestOptions = {
    url: `ehrAdmin/users/${userId}`,
    method: 'get',
  };

  return DvAxiosRequest(requestOptions, function (response) {
    return {
      status: 1,
      results: CamelcaseKeys(response.data, { "deep": true })
    };
  });
}

const getUserPermissionsService = (userId) => {
  const requestOptions = {
    url: `ehrAdmin/users/${userId}/permissions`,
    method: 'get',
  };

  return DvAxiosRequest(requestOptions, function (response) {
    return {
      status: 1,
      results: CamelcaseKeys(response.data, { "deep": true })
    };
  });
}

const getUserBackgroundLogsService = (userId, filters) => {
  const params = new URLSearchParams(filters);
  const requestOptions = {
    url: `ehrAdmin/users/${userId}/backgroundLogs?` + params,
    method: 'get',
    data: snakecaseKeys(filters, { deep: true })
  };

  return DvAxiosRequest(requestOptions, function (response) {
    return {
      status: 1,
      results: CamelcaseKeys(response.data, { "deep": true })
    };
  });
}

const getClinicBackgroundLogsService = (clinicId, filters) => {
  const params = new URLSearchParams(filters);
  const requestOptions = {
    url: `ehrAdmin/clinics/${clinicId}/backgroundLogs?` + params,
    method: 'get',
    data: snakecaseKeys(filters, { deep: true })
  };

  return DvAxiosRequest(requestOptions, function (response) {
    return {
      status: 1,
      results: CamelcaseKeys(response.data, { "deep": true })
    };
  });
}

const getUserAuditLogsService = (filters) => {
  const params = new URLSearchParams(snakecaseKeys(filters));
  const requestOptions = {
    url: `actionLogs?` + params,
    method: 'get' ,
  };

  return DvAxiosRequest(requestOptions, function (response) {
    return {
      status: 1,
      results: CamelcaseKeys(response.data, { "deep": true })
    };
  });
}

const changeUserPasswordService = (userId, values) => {
  const requestOptions = {
    url: `ehrAdmin/users/${userId}/resetPassword`,
    method: 'put',
    data: snakecaseKeys(values, { deep: true })
  };

  return DvAxiosRequest(requestOptions, function (response) {
    return {
      status: 1,
      results: CamelcaseKeys(response.data, { "deep": true })
    };
  });
}

const changeUserStatusService = (userId, status) => {
  const bodyToSend = {
    "user_status": status,
  };

  const requestOptions = {
    url: `ehrAdmin/users/${userId}/userStatus`,
    method: 'put',
    data: snakecaseKeys(bodyToSend, { deep: true })
  };

  return DvAxiosRequest(requestOptions, function (response) {
    return {
      status: 1,
      results: CamelcaseKeys(response.data, { "deep": true })
    };
  });
}

const getClinicNamesService = () => {
  const requestOptions = {
    url: `ehrAdmin/clinics/names`,
    method: 'get',
  };

  return DvAxiosRequest(requestOptions, function (response) {
    return {
      status: 1,
      results: CamelcaseKeys(response.data, { "deep": true })
    };
  });
};

const getUserNamesService = () => {
  const requestOptions = {
    url: `ehrAdmin/users`,
    method: 'get',
  };

  return DvAxiosRequest(requestOptions, function (response) {
    return {
      status: 1,
      results: CamelcaseKeys(response.data, { "deep": true })
    };
  });
};

const getDailyStatisticsForDayService = (date) => {
  const requestOptions = {
    url: `ehrAdmin/generalInfos/dailyStatistics/${date}`,
    method: 'get',
  };

  return DvAxiosRequest(requestOptions, function (response) {
    return {
      status: 1,
      results: CamelcaseKeys(response.data, { "deep": true })
    };
  });
};

const getDailyStatisticsForPeriodService = (dateFromAsMoment, dateUntilAsMoment) => {
  const requestOptions = {
    url: `ehrAdmin/generalInfos/dailyStatistics?date_from=${dateFromAsMoment.format('YYYY-MM-DD')}&date_until=${dateUntilAsMoment.format('YYYY-MM-DD')}`,
    method: 'get',
  };

  return DvAxiosRequest(requestOptions, function (response) {
    return {
      status: 1,
      results: CamelcaseKeys(response.data, { "deep": true })
    };
  });
};

const getWeeklyStatisticsService = (dateAsMoment) => {
  const requestOptions = {
    url: `ehrAdmin/generalInfos/weeklyStatistics/${dateAsMoment.format('YYYY-MM-DD')}`,
    method: 'get',
  };

  return DvAxiosRequest(requestOptions, function (response) {
    return {
      status: 1,
      results: CamelcaseKeys(response.data, { "deep": true })
    };
  });
};

const getAvailablePermissionsService = () => {
  const requestOptions = {
    url: `ehrAdmin/permissions`,
    method: 'get',
  };

  return DvAxiosRequest(requestOptions, function (response) {
    return {
      status: 1,
      results: CamelcaseKeys(response.data, { "deep": true })
    };
  });
}

export {
  getGeneralInfosService, getClinicsWithMostPatientsService, getUsersWithMostPatientsService,
  getBackgroundLogsService, getGeneralErrorLogsService, getClinicsService, getDatabasesService, 
  getBackupsService, getLogsDataService, createNewClinicService, updateClinicService, getSingleClinicDetailsService,
  createNewUserService, updateUserService, getUserDetailsService, getUserPermissionsService, changeUserPasswordService, changeUserStatusService,
  getUserBackgroundLogsService, getUserAuditLogsService, getClinicNamesService,
  getUserNamesService, getClinicBackgroundLogsService, getDailyStatisticsForDayService, getDailyStatisticsForPeriodService, getWeeklyStatisticsService,
  getAvailablePermissionsService
};
